/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetGoalRequest} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'
import {GetGoalResponse} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'


export const getGoal = (request: GetGoalRequest, options?: CashRequestOptions) => post<GetGoalRequest, GetGoalResponse>("/2.0/cash/get-goal", request, {...options, rejectOnError: true })